import { render, staticRenderFns } from "./recommend-colors.vue?vue&type=template&id=4fa38231"
import script from "./recommend-colors.vue?vue&type=script&lang=js"
export * from "./recommend-colors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports